import PropTypes from 'prop-types';

const SelectUpIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 34.098c0 1.4.505 2.748 1.465 3.826 1.97 2.101 5.203 2.101 7.173 0l15.356-16.329L39.35 37.924c1.97 2.101 5.202 2.101 7.172 0 1.97-2.102 1.97-5.55 0-7.653L27.58 10.063A4.843 4.843 0 0 0 23.994 8.5c-1.364 0-2.627.593-3.587 1.563L1.465 30.27A5.821 5.821 0 0 0 0 34.098z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

SelectUpIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

SelectUpIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default SelectUpIcon;
